export const quoteSlider = ({ count, autoplay = false, interval = 8 }) => ({
    count,
    active: 0,
    ready: false,
    running: false,
    hovering: false,
    reducedMotion: false,
    timer: null,
    interval: Number.isFinite(Number(interval)) ? Math.min(60, Math.max(5, Number(interval))) * 1000 : 8000,

    init() {
        this.motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        this.reducedMotion = this.motionQuery.matches;
        this.running = Boolean(autoplay) && !this.reducedMotion && this.count > 1;
        this.onMotionChange = (event) => {
            this.reducedMotion = event.matches;
            if (this.reducedMotion) this.running = false;
            this.schedule();
        };
        this.onVisibilityChange = () => this.schedule();
        this.motionQuery.addEventListener("change", this.onMotionChange);
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        this.ready = true;
        this.schedule();
    },

    schedule() {
        window.clearTimeout(this.timer);
        this.timer = null;
        if (!this.running || this.hovering || this.reducedMotion || document.hidden || this.count < 2) return;
        this.timer = window.setTimeout(() => {
            this.active = (this.active + 1) % this.count;
            this.schedule();
        }, this.interval);
    },

    move(direction) {
        this.pause();
        this.active = (this.active + direction + this.count) % this.count;
    },

    pause() {
        this.running = false;
        this.schedule();
    },

    toggle() {
        this.running = !this.running;
        this.schedule();
    },

    hover(value) {
        this.hovering = value;
        this.schedule();
    },

    destroy() {
        window.clearTimeout(this.timer);
        this.motionQuery.removeEventListener("change", this.onMotionChange);
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    },
});
